import React from "react";

export const MyAuthContext = React.createContext();
